export const SET_SIDE_PANEL_SELECTED_EVENT = 'SET_SIDE_PANEL_SELECTED_EVENT';

export const setSidePanelSelectedEvent = event => ({
  type: SET_SIDE_PANEL_SELECTED_EVENT,
  payload: event,
});

export const SET_SIDE_PANEL_SHIFT = 'SET_SIDE_PANEL_SHIFT';

export const setSidePanelShift = shift => ({
  type: SET_SIDE_PANEL_SHIFT,
  payload: shift,
});

export const SET_SIDE_PANEL_COVERAGE_GAP = 'SET_SIDE_PANEL_COVERAGE_GAP';

export const setSidePanelCoverageGap = gap => ({
  type: SET_SIDE_PANEL_COVERAGE_GAP,
  payload: gap,
});

export const SET_SIDE_PANEL_SELECTED_GAP_INDEX =
  'SET_SIDE_PANEL_SELECTED_GAP_INDEX';

export const setSidePanelSelectedGapIndex = index => ({
  type: SET_SIDE_PANEL_SELECTED_GAP_INDEX,
  payload: index,
});

export const SET_SIDE_PANEL_DIM_ENABLED = 'SET_SIDE_PANEL_SELECTED_DIM_ENABLED';

export const setSidePanelDimEnabled = enabled => ({
  type: SET_SIDE_PANEL_DIM_ENABLED,
  payload: enabled,
});

export const SET_SIDE_PANEL_GAP_DATE_RANGE = 'SET_SIDE_PANEL_GAP_DATE_RANGE';

export const setSidePanelGapDateRange = ({ startDate, endDate }) => ({
  type: SET_SIDE_PANEL_GAP_DATE_RANGE,
  payload: { startDate, endDate },
});
